import type {
  ConditionHistoryAssessmentOf,
  ConditionHistoryDto,
  ConditionHistoryPathology,
  ConditionHistoryTeleResponseReview,
  ConditionHistoryConditionDetails,
  ConditionHistoryTeledermatology,
  ConditionHistoryTriage,
  ConditionHistoryDiagnosis,
} from '@dermloop/api-dtos';
import { DermloopAssessmentTypeEnum } from '@dermloop/static-values';

function isConditionHistoryAssessmentOf<T>(
  assessmentType: DermloopAssessmentTypeEnum,
): (
  conditionHistory: ConditionHistoryDto | undefined,
) => conditionHistory is ConditionHistoryAssessmentOf<T> {
  return (
    conditionHistory: ConditionHistoryDto | undefined,
  ): conditionHistory is ConditionHistoryAssessmentOf<T> =>
    conditionHistory?.assessmentType === assessmentType;
}

export const isConditionHistoryTriage =
  isConditionHistoryAssessmentOf<ConditionHistoryTriage>(
    DermloopAssessmentTypeEnum.ConditionTriage,
  );

export const isConditionHistoryConditionDetails =
  isConditionHistoryAssessmentOf<ConditionHistoryConditionDetails>(
    DermloopAssessmentTypeEnum.ConditionDetails,
  );

export const isConditionHistoryPathology =
  isConditionHistoryAssessmentOf<ConditionHistoryPathology>(
    DermloopAssessmentTypeEnum.Pathology,
  );

export const isConditionHistoryTeledermatology =
  isConditionHistoryAssessmentOf<ConditionHistoryTeledermatology>(
    DermloopAssessmentTypeEnum.Teledermatology,
  );

export const isConditionHistoryResponseReview =
  isConditionHistoryAssessmentOf<ConditionHistoryTeleResponseReview>(
    DermloopAssessmentTypeEnum.TeleResponseReview,
  );

export const isConditionHistoryDiagnosis =
  isConditionHistoryAssessmentOf<ConditionHistoryDiagnosis>(
    DermloopAssessmentTypeEnum.NewConditionDiagnosis,
  );
